import { Platform, CommonRuntime } from "utils/runtime";
import { middleEast } from "./currency";

export const formatPriceWithPoint = function (price: number | string, bit = 2) {
	if (typeof price === "string") {
		price = parseFloat(price);
	}
	const base = Math.pow(10, bit);

	return (Math.round(price * base) / base).toFixed(bit);
};

export const stringToPrice = function (priceString: string) {
	// eslint-disable-next-line no-useless-escape
	return parseFloat(priceString.replace(/[^\.\d]/g, ""));
};

export function transferMixUnitPrice(integerPrice: number) {
	const price = integerPrice / 100;
	return Number(price.toFixed(2));
}

/** 下划线价格单位 */
const PriceUnderlinkSymbol = {
	MXN: "$",
	CHF: "₣",
};

// M端货币名称需要转换缩写
const PriceCurrencyFormat = {
	USD: "US",
	AUD: "AU",
	HKD: "HK",
	NZD: "NZ",
	JPY: "JP",
	COP: "COL",
};

// M端货币符号需要特殊展示的
const MSpecialSymbol = {
	RUB: "₽",
	EGP: "E£",
	INR: "Rs.",
};

// PC、M端价格都需要展示货币的
const priceNeedCurrency = [
	"JOD",
	"CAD",
	"RON",
	"BGN",
	"HUF",
	"TRY",
	"KZT",
	"HRK",
	"CLP",
	"ZAR",
	"THB",
	"TRY",
	"MXN",
	"ARS",
];

function transformPriceByCurrency(currency: string, price: string) {
	if (["BRL"].includes(currency)) {
		return price.replace(".", ",");
	}
	return isNaN(+price) ? price : Number(price);
}

export const commonTransformProductPrice = (
	price: string,
	originPrice: string,
	runtime: CommonRuntime,
	priceGraph: string,
) => {
	const { currency } = runtime;
	let priceCurrency = runtime.platform === Platform.WEB ? currency : ""; // M端默认为空, 未处理的货币不展示
	const originPriceCurrency = ""; // 划线价格前面默认是没有货币
	let priceSymbol: string = priceGraph;
	let originPriceSymbol: string = priceGraph;
	let originPriceBr = false; // 扩展划线价格是否换行展示
	// 中东国家不展示货币符号
	if (middleEast.includes(currency)) {
		priceSymbol = "";
		originPriceSymbol = "";
		priceCurrency = currency;
	} else if (["CHF"].includes(currency)) {
		originPriceSymbol = PriceUnderlinkSymbol[currency.toLocaleUpperCase()];
		priceCurrency = currency;
	} else if (priceNeedCurrency.includes(currency)) {
		priceCurrency = currency;
	} else if (
		runtime.platform === Platform.MWEB &&
		["USD", "AUD", "HKD", "NZD", "JPY", "COP"].includes(currency)
	) {
		// 移动端货币展示不下需要缩写处理
		priceCurrency = PriceCurrencyFormat[currency.toLocaleUpperCase()];
	} else if (runtime.platform === Platform.WEB && ["IDR", "KZT"].includes(currency)) {
		// 按照已有逻辑，PC端对IDR、KZT货币划线价格换行处理
		originPriceBr = true;
		priceCurrency = currency;
	} else if (runtime.platform === Platform.MWEB && ["RUB", "EGP", "INR"].includes(currency)) {
		// PC、M端货币符号存在差异处理
		priceSymbol = MSpecialSymbol[currency];
		originPriceSymbol = MSpecialSymbol[currency];
	}

	return {
		price: transformPriceByCurrency(currency, price),
		originPrice: transformPriceByCurrency(currency, originPrice),
		priceCurrency,
		originPriceCurrency,
		priceSymbol,
		originPriceSymbol,
		originPriceBr,
	};
};